import React, { useEffect, useState, useRef } from "react";
import useOnScreen from "../../../hooks/useOnScreen";
import styles from "./GeneratingInterest.module.scss";
import ArchitecutureImage from "../../../Assets/Images/architecuture.png";
import ShowImage from "../../../Assets/Images/show-imgae.png";
export default function GeneratingInterest() {
	const ref = useRef(null);

	const [reveal, setReveal] = useState(false);
	const onScreen = useOnScreen(ref);

	useEffect(() => {
		if (onScreen) setReveal(onScreen);
	}, [onScreen]);
	return (
		<div data-scroll-section>
			<section className={styles.GeneratingInterestAlignment}>
				<div className={styles.grid}>
					<div className={styles.gridItems}>
						<div className={styles.sectionTitle}>
							<div className={styles.mobileViewTextShow}>
								<h5>DESIGN & value engIneering</h5>
							</div>
							<h1>
								Our Commitment to <b>ESG</b>
							</h1>

							<p>
								At LRC Group, we recognize that our success as a pan-European
								real estate investment and fund manager is intrinsically linked
								to the well-being of the environment, the communities we operate
								in, and the governance practices we uphold.
							</p>
							<p>
								Further, we understand the important role that the real estate
								sector can play in tackling key sustainability issues such as
								climate change, biodiversity loss and social inequalities, and
								we are committed to advancing the transition towards a more
								sustainable built environment.
							</p>
							<p>
								<p>
									We seek to align with our stakeholders’ expectations by
									incorporating ESG matters into our investment decisions. Doing
									so requires an ESG Framework that integrates responsible
									investment practices into business operations and asset
									stewardship.
								</p>
							</p>
						</div>
						<div className={styles.fullViewImage}>
							<img
								src={ShowImage}
								alt="ShowImage"
								className="flipImage"
								data-scroll
								data-scroll-repeat
							/>
						</div>
					</div>
					<div className={styles.gridItems}>
						<a>DESIGN & value engIneering</a>
						<div className={styles.imageStyle}>
							<img
								src={ArchitecutureImage}
								alt="ArchitecutureImage"
								className="flipImage"
								data-scroll
								data-scroll-repeat
							/>
							{/* <h6 className="italic-class">Building</h6> */}
						</div>
						<div className={styles.imageRelatedText}>
							<span>
								We believe that integrating Environmental, Social and Governance
								(ESG) principles into our business is not just a responsibility
								but a driver of long-term value creation for our stakeholders,
								and the LRC ESG Framework is designed to respond to that, to
								support and guide our decision-making processes.
							</span>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}
